import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from '@tanstack/react-query';
import { Toaster, toast } from 'sonner';
import { router } from './router';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (err, query) => {
      if ((query.meta as { silent?: boolean } | undefined)?.silent) return;
      toast.error('Не удалось загрузить данные', {
        description: err instanceof Error ? err.message : undefined,
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (err) => {
      toast.error('Действие не выполнено', {
        description: err instanceof Error ? err.message : undefined,
      });
    },
  }),
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster
        position="bottom-right"
        theme="dark"
        closeButton
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--bg-elevated)',
            border: '1px solid var(--border-strong)',
            color: 'var(--text)',
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>,
);
